module.exports = __webpack_public_path__ + "633200b989b328dcbbc0ca675d839504.svg";